import NavItem from "./NavItem";

type NavBarContentProps = {
    generalNavItems: NavItem[];
    unProcessedFocusMailCount: number;
    smartlabelNavItems: NavItem[];
    customviewsNavItems: NavItem[];
};

export default class NavBarContent {
    generalNavItems: NavItem[];

    unProcessedFocusMailCount: number; // TODO : Remove once the dedicated deep focus hook is implemented in the SDK

    smartlabelNavItems: NavItem[];

    customviewsNavItems: NavItem[];

    constructor({
        generalNavItems,
        unProcessedFocusMailCount,
        smartlabelNavItems,
        customviewsNavItems,
    }: NavBarContentProps) {
        this.generalNavItems = generalNavItems;
        this.unProcessedFocusMailCount = unProcessedFocusMailCount;
        this.smartlabelNavItems = smartlabelNavItems;
        this.customviewsNavItems = customviewsNavItems;
    }
}
